/**
 * Labstep
 */

import type { Device } from 'labstep-web/models/device.model';
import type { Experiment } from 'labstep-web/models/experiment.model';
import type { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type { Molecule } from 'labstep-web/models/molecule.model';
import type { OrderRequest } from 'labstep-web/models/order-request.model';
import type { PremiumFeature } from 'labstep-web/models/organization.model';
import type { Protocol } from 'labstep-web/models/protocol.model';
import type { PurchaseOrder } from 'labstep-web/models/purchase-order.model';
import type { Resource } from 'labstep-web/models/resource.model';
import type { ResourceItem } from 'labstep-web/models/resource-item.model';
import type { ResourceLocation } from 'labstep-web/models/resource-location.model';
import type { User } from 'labstep-web/models/user.model';

export type MetadataEntityNameType = 'metadata';

export enum MetadataType {
  default = 'default',
  date = 'date',
  datetime = 'datetime',
  numeric = 'numeric',
  options = 'options',
  molecule = 'molecule',
  sequence = 'sequence',
  file = 'file',
  entity_relation = 'entity_relation',
}

export enum MetadataTypeValues {
  default = 'Text',
  date = 'Date',
  datetime = 'Date and time',
  numeric = 'Numeric',
  options = 'Options',
  molecule = 'Chemistry',
  sequence = 'Sequence',
  file = 'File / Image',
  entity_relation = 'Relation',
}

export type IMETADATA_TYPES = {
  label: MetadataTypeValues;
  value: MetadataType;
};

export type IMETADATA_FIELDS = {
  [key in MetadataType]: {
    fields: string[];
    fieldsToReset?: string[];
    fieldsToDelete?: string[];
  };
};

export type MetadataOptionsValues = {
  [key: string]: boolean;
};

export type MetadataOptions = {
  // keys: string[];
  values: MetadataOptionsValues;
  is_allow_multiple: boolean;
  is_allow_add: boolean;
};

export interface MetadataCreateProps {
  parentName: string;
  parentId: number;
  createBody: {
    template_id: number;
    molecule?: typeof Molecule.createBodyDefault;
    type?: MetadataType;
  };
  type: MetadataType;
  sequence?: string;
  molecule?: string;
}

export type IMETADATA_PREMIUM_OPTION = {
  label: MetadataTypeValues;
  value: MetadataType;
  show?: boolean;
  premiumFeature?: PremiumFeature;
  premiumFeatureEnabled?: boolean;
};

export type MetadataParent =
  | Device
  | Experiment
  | ExperimentWorkflow
  | OrderRequest
  | Protocol
  | PurchaseOrder
  | Resource
  | ResourceItem
  | ResourceLocation
  | User;
